import styled from "@emotion/styled";
import { fontFamily, dataViz, dataVizLayout, dataVizTypography } from "@atlas-int/tokens";
import { fadeInAnimation } from "@atlas-int/tokens";

export { fadeInAnimation };

export const primaryFont = `'${fontFamily.base}', sans-serif`;
export const secondaryFont = fontFamily.mono;

export const backgroundDark = dataViz.backgroundDark;
export const lightBorderColor = dataViz.lightBorder;

export const backgroundMedium = dataViz.backgroundMedium;
export const baseColor = dataViz.textDark;

export const tooltipHeaderBackgroundColor = dataViz.tooltipHeader;

export const chartMargin = dataVizLayout.defaultChartMargin;

export { noOutlineOnFocus, radioButtonCss } from "@atlas-int/tokens";

export const AxisGElement = styled.g`
  pointer-events: none;

  & text {
    font-family: '${fontFamily.base}', sans-serif;
    font-size: ${dataVizTypography.axisLabel};
    fill: ${dataViz.axisText};
  }
`;
